import React, {useState} from "react";
import {FormControl} from "react-bootstrap";
import Style from "../Style.module.css";
import {useNavigate} from "react-router-dom";
import * as UserService from "../../api/UserService";
import {useTranslation} from "react-i18next";
import InstagramWarning from "../InstagramWarning";
import TranslationSwitch from "../../translation/translationSwitch";

function LoginPage() {
    const [email, setEmail] = useState("")
    const [pass, setPass] = useState("")
    const { t } = useTranslation('translation', { keyPrefix: 'loginPage' });
    const nav = useNavigate()

    function redirectWhenAuth() {
        nav("/mentor/cabinet")
    }

    function redirectWhenNotAuth() {
        window.alert(t('wrongEmailOrPassword'))
    }
    function ResolveEmail(event) {
        setEmail(event.target.value)
    }

    function ResolvePass(event) {
        setPass(event.target.value)
    }

    function authorise() {
        UserService.postLoginData(email, pass, redirectWhenAuth, redirectWhenNotAuth)
    }

    return(
        <div className={Style.startPageMainContainer}>
            <div style={{position:"absolute", top: "10px", right:"12px"}}>
                <TranslationSwitch></TranslationSwitch>
            </div>
            <InstagramWarning/>
            <div className={Style.setupPageBlocks}>
                <header>{t('enterEmail')}</header>
                <FormControl
                    placeholder={t('emailPlaceholder')}
                    aria-label="Email"
                    aria-describedby="basic-addon1"
                    value={email}
                    onChange={event => ResolveEmail(event)}
                />
                <header>{t('enterPassword')}</header>
                <FormControl
                    placeholder={t('passwordPlaceholder')}
                    aria-label="Password"
                    aria-describedby="basic-addon1"
                    value={pass}
                    onChange={event => ResolvePass(event)}
                    type={"password"}
                />
                <br></br>
                <div style={{display: "flex", alignItems: "center", flexDirection: "column", gap:"12px"}}>
                    <div className={`${Style.defaultButtonColourAndText} ${Style.buttonWithLink}`} onClick={()=>{
                        authorise()
                    }}>{t('login')}</div>
                    <a className={Style.changeLink} href={"/forgot_password"}>{t('forgotPassword')}</a>
                    <a className={Style.changeLink} href={"/register"}>{t('newUserRegister')}</a>
                </div>
            </div>
        </div>

    )
}

export default LoginPage